import Button from "@src/components/Button/Button";
import CharacterCard from "@src/components/CharacterCard/CharacterCard";
import Loader from "@src/components/Loader/Loader";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import "./styles/index.sass";
import { PlusIcon } from "@heroicons/react/24/solid";
import Page from "@src/layout/Page";
import { Character, CharacterListVersion } from "@src/types/global";
import { getAllCharacters } from "@src/services/requests/characters";
const CharactersIndex = () => {
    const characterQuery = useQuery({
        queryKey: ["characters"],
        queryFn: getAllCharacters,
        select: (data) => data.characters
    });

    const navigate = useNavigate();
    return (
        <Page>
            <div className="characters">
                <header>
                    <h1>Character page</h1>
                    <div>
                        <Button
                            preset="primary"
                            fn={() => navigate("/characters/new")}
                        >
                            <PlusIcon className="icon" /> Create a character
                        </Button>
                    </div>
                </header>
                <div className="characters__container">
                    {characterQuery.isLoading ? (
                        <Loader />
                    ) : characterQuery.isSuccess ? (
                        <div className="characters__container__list">
                            {characterQuery.data.map(
                                (char: Character) => {
                                    return (
                                        <CharacterCard
                                            key={char.id}
                                            character={char as any as CharacterListVersion}
                                            onClick={() =>
                                                navigate(`/${char.id}`)
                                            }
                                            type="vertical"
                                        />
                                    );
                                },
                            )}
                        </div>
                    ) : (
                        <div>Could not fetch characters</div>
                    )}
                </div>
            </div>
        </Page>
    );
};
export default CharactersIndex;
